import React, { useState, useEffect } from "react";
import { Subscribe } from "unstated";
import { Route, Switch, Redirect } from "react-router-dom";
import { NotFound404, BaseLayout } from "idc-ui-react";
// Our modules
import { store } from "../../stores/Main";
import onUrlChange from "../../stores/onUrlChange";
import Content from "./Content";
import { getNavMenuGroups } from "../../utilities/NavMenuHelper";
import { ContentContextBar } from "../../components";

function Reports({ store, match }) {
  const { modules } = store.state.loggedInUser;
  const [navMenuGroups, setNavMenuGroups] = useState();

  useEffect(() => {
    if (!modules) return;
    // Get menu items that user is allowed to see
    setNavMenuGroups(getNavMenuGroups(modules, "reports"));
  }, [modules]);

  return modules ? (
    <BaseLayout
      store={store}
      match={match}
      onUrlChange={onUrlChange}
      navMenuGroups={navMenuGroups}
    >
      <ContentContextBar store={store} match={match} />
      <Switch>
        <Route
          path="/:page"
          exact
          render={() => <Redirect to="/reports/reports" />}
        />
        <Route path="/:page/:category?/:action?/:id?" component={Content} />
        <Route component={NotFound404} />{" "}
      </Switch>
    </BaseLayout>
  ) : null;
}

const StoreWrapper = match => (
  <Subscribe to={[store]}>
    {store => <Reports store={store} {...match} />}
  </Subscribe>
);

export default StoreWrapper;
